/* unplugin-vue-components disabled */export default {
  name: 'UserMenu',
  data: () => ({}),
  computed: {
    ...mapGetters(['username', 'firstName', 'profilePicture', 'initials'])
  },
  methods: {
    ...mapActions(['logout'])
  }
};